import React from 'react';
import { get } from 'lodash';

import Schema from '../../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import { getLocalstorageToken } from '../../../../../../../context/AuthHelper';
import EigenmittelVN, { GetVNEigenmittelFormStruc } from './EigenmittelVN';
const P = Schema.attributes;

export const GetEigenmittelVN = (application: any, kostenKategories: any) => {
	const OrgaStruc = [
		{
			label: 'Antragsteller',
			content: <EigenmittelVN kostentraeger="Antragsteller" unternehmenId={get(getLocalstorageToken(), 'organisationId')} />,
			formStruc: GetVNEigenmittelFormStruc(
				application,
				get(getLocalstorageToken(), 'organisationId'),
				'Antragsteller',
				kostenKategories,
			),
		},
	];
	const PartnerStruc = get(application, P.Zuwendungsantrag.schema.attributes.Partner.path, []).map((ele: any, i: number) => {
		return {
			label: `Partner ${i + 1}`,
			content: <EigenmittelVN kostentraeger="Projektpartner" unternehmenId={get(ele, 'Unternehmen.id')} />,
			formStruc: GetVNEigenmittelFormStruc(application, get(ele, 'Unternehmen.id'), 'Projektpartner', kostenKategories),
		};
	});
	return [...OrgaStruc, ...PartnerStruc];
};
